<tr class="detaljer-rad">
  <td class="ekspander"><!--vis/skjul detaljer--></td>
  <td class="advarsler"><!--advarsel--></td>
  <td class="navn"><!--navn--></td>
  <td colspan="7" class="detaljer">
    <tittel-verdi-samling stil="horisontal">
      <tittel-verdi tittel="{{ 'E-post' | translate }}" verdi="{{aksjeeier().epost | standard}}"/>
      @if(erPerson()){
        <tittel-verdi tittel="{{ 'Fødselsdato' | translate }}" verdi="{{aksjeeier().foedselsdato | plaindate}}"/>
      } @else {
        <tittel-verdi tittel="{{'Organisasjonsnummer' | translate}}" verdi="{{aksjeeier().organisasjonsnummer | standard | standard}}"/>
      }
      <tittel-verdi tittel="{{'Adresse' | translate}}" verdi="{{aksjeeier().adresse | standard}}"/>
    </tittel-verdi-samling>

    @if (manglendeInformasjon().length > 0) {
      <inline-melding type="feil">
        {{'Aksjeloven §4-5 krever at følgende informasjon er registrert for aksjonærer:' | translate}}
        <ul>
          <!-- felt oversettes i aksjeeier().ts -->
          @for (felt of manglendeInformasjon(); track $index) {
            <li>{{ felt }}</li>
          }
        </ul>
      </inline-melding>
    }

    <tittel-verdi stil="vertikal--med-linje" tittel="{{'Beholdningshistorikk' | translate}}" class="beholdninger-overskrift">
      <verdi>
        @if(aksjeeierDetaljer().beholdningshistorikk.length == 0){
          <tips>
            {{ "Ingen beholdning registrert." | translate }}
            <!-- @todo kun vis dersom tilgang-->
            <a (click)="registrerBeholdning()">{{ "Klikk her for å registrere beholdninger." | translate }}</a>
          </tips>
        }
      </verdi>
    </tittel-verdi>
  </td>
  <td class="meny"><!--meny--></td>
</tr>

@if(aksjeeierDetaljer().beholdningshistorikk.length > 0){
<tr class="beholdninger-rad">
  <th class="ekspander"><!--vis/skjul detaljer--></th>
  <th class="advarsler"><!--advarsel--></th>
  <th class="navn"><!--navn--></th>
  <th class="innføringsdato">{{ "Innføringsdato" | translate }}</th>
  <th class="andel">{{ "Eierandel" | translate }}</th>
  <th class="antall">{{ "Antall aksjer" | translate }}</th>
  <th class="klasse">{{ "Klasse" | translate }}</th>
  <th class="nummer">{{ "Nummer" | translate }}</th>
  <th colspan="2" class="kommentar">{{ "Kommentar" | translate }}</th>
  <th class="meny"><!--meny--></th>
</tr>
}

@for (beholdning of aksjeeierDetaljer().beholdningshistorikk; track beholdning.id){
<tr class="beholdninger-rad">
  <td class="ekspander"><!--vis/skjul detaljer--></td>
  <td class="advarsler"><!--advarsel--></td>
  <td class="navn"><!--navn--></td>
  <td class="innføringsdato">{{ beholdning.gyldigFraTil.start | plaindate:'medium' }}</td>
  <td class="andel">{{ beholdning.eierandel | prosent }}</td>
  <td class="antall">{{ beholdning.antall }}</td>
  <td class="klasse">{{ beholdning.aksjeklasse?.navn }}</td>
  <td class="nummer">{{ beholdning.aksjenummer }}</td>
  <td colspan="2" class="kommentar"><html-formatert [innhold]="beholdning.kommentar"/></td>
  <td class="meny"></td>
</tr>
}
